/**
 * Firebase Configuration
 *
 * This module provides Firebase configuration loaded from environment variables.
 * Each environment (dev, qa, prod) has its own .env.* file with the appropriate
 * Firebase credentials.
 */

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

/**
 * Firebase configuration loaded from environment variables.
 * All environments use the same env vars which are set per-environment in .env.* files.
 */
const firebaseConfig: FirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

/**
 * Get Firebase configuration.
 */
export function getFirebaseConfig(): FirebaseConfig {
  return firebaseConfig;
}
